<template>
  <div class="customerInvoiceDetail">
    <div style="padding: 0 10px;height: calc(100vh - 140px);overflow-y: auto;">
      <el-form
        ref="invoiceDetailRef"
        :model="invoiceDetail"
        label-position="top"
        size="small"
        :disabled="viewType === 1"
      >
        <el-card class="box-card" style="margin-bottom: 10px;">
          <div slot="header" class="clearfix">
            <!-- 基本信息 -->
            <span>{{ $t('collectionCenter.basicInformation') }}</span>
            <el-button
              v-if="viewType !== 1"
              size="small"
              type="primary"
              style="margin-left: 30px"
              @click="popoverVisible = !popoverVisible"
            >{{ $t('mdfeTranslate.OneClickFillIn') }}
            </el-button>
            <el-popover
              v-model="popoverVisible"
              placement="bottom"
              trigger="manual"
            >
              <div>
                <el-form
                  ref="inputFormRef"
                  :model="inputForm"
                  size="small"
                  label-position="top"
                >
                  <el-form-item
                    :label="$t('mdfeTranslate.InvoiceCNPJ')"
                    prop="cnpj"
                    :rules="[{required: true, validator: checkcnpj, trigger: ['blur', 'change']}]"
                  >
                    <el-input v-model="inputForm.cnpj" style="width: 300px;" :placeholder="$t('collectionCenter.pleaseInput')" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('mdfeTranslate.StateAbbreviationUF')"
                    prop="state"
                    :rules="[{required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change']}]"
                  >
                    <el-select
                      v-model="inputForm.state"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      filterable
                      style="width: 300px;"
                      @change="stateChangeOption"
                    >
                      <el-option
                        v-for="item in senderStateList"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.shortName"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
                <div style="text-align: right;">
                  <el-button size="small" @click="popoverVisible = false">{{ $t('collectionCenter.close') }}</el-button>
                  <el-button type="primary" size="small" @click="saveInput">{{ $t('collectionCenter.Confirm') }}</el-button>
                </div>
              </div>
            </el-popover>
          </div>
          <div>
            <el-row :gutter="10">
              <el-col :span="6">
                <!-- 客户编码 -->
                <el-form-item
                  :label="$t('mdfeTranslate.CustomerCode')"
                  prop="customerId"
                  :rules="[{required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change']}]"
                >
                  <el-select
                    v-model="invoiceDetail.customerId"
                    :placeholder="$t('basicData.PleaseSelect')"
                    style="width: 100%;"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :disabled="viewType === 2"
                    :remote-method="getCustomerOption"
                    @visible-change="getCustomerOptionDialog"
                    @change="customerChange"
                  >
                    <el-option
                      v-for="item in customerOption"
                      :key="item.id"
                      :label="item.username + '（' + item.id + '）'"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 开票CNPJ -->
                <el-form-item
                  :label="$t('mdfeTranslate.InvoiceCNPJ')"
                  prop="invoiceCnpj"
                  :rules="[{required: true, validator: checkcnpj, trigger: ['blur', 'change']}]"
                >
                  <el-input v-model="invoiceDetail.invoiceCnpj" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 开票IE -->
                <el-form-item
                  :label="$t('mdfeTranslate.InvoiceIE')"
                  prop="invoiceIe"
                  :rules="[{required: true, validator: ieNumber, trigger: ['blur', 'change']}]"
                >
                  <el-input v-model="invoiceDetail.invoiceIe" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 公司简称 -->
                <el-form-item
                  :label="$t('mdfeTranslate.CompanyAbbreviation')"
                  prop="companyShortName"
                  :rules="[{required: false, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change']}]"
                >
                  <el-input v-model="invoiceDetail.companyShortName" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 账号名称 -->
                <el-form-item :label="$t('customerManagements.AccountName')" prop="customerName">
                  <el-input v-model="invoiceDetail.customerName" disabled :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- 公司全称 -->
                <el-form-item
                  :label="$t('mdfeTranslate.CompanyFullName')"
                  prop="companyFullName"
                  :rules="[{required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change']}]"
                >
                  <el-input v-model="invoiceDetail.companyFullName" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-card class="box-card" style="margin-bottom: 10px;">
          <div slot="header" class="clearfix">
            <!-- 地址信息 -->
            <span>{{ $t('seller.addressInfo') }}</span>
          </div>
          <div>
            <el-row :gutter="10">
              <el-col :span="6">
                <!-- 邮编 -->
                <el-form-item
                  :label="$t('basicData.zipCode')"
                  prop="postalCode"
                  :rules="[{required: true, validator: checkPostcode, trigger: ['blur', 'change']}]"
                >
                  <el-input v-model="invoiceDetail.postalCode" :placeholder="$t('collectionCenter.pleaseInput')" @change="changePostalCode" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 州缩写UF -->
                <el-form-item
                  :label="$t('mdfeTranslate.StateAbbreviationUF')"
                  prop="uf"
                  :rules="[{required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change']}]"
                >
                  <el-select
                    v-model="invoiceDetail.uf"
                    :placeholder="$t('placeOrder.pleaseInput')"
                    clearable
                    filterable
                    style="width: 100%"
                    @change="stateChangeOption"
                  >
                    <el-option
                      v-for="item in senderStateList"
                      :key="item.id"
                      :label="item.shortName"
                      :value="item.shortName"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 城市 -->
                <el-form-item
                  :label="$t('collectionCenter.city')"
                  prop="city"
                  :rules="[{required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change']}]"
                >
                  <el-select
                    v-model="invoiceDetail.city"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    :remote-method="getSenderCity"
                    class="formTable"
                    filterable
                    remote
                    reserve-keyword
                    style="width: 100%"
                    @visible-change="cityOptionOpen()"
                  >
                    <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 街区 -->
                <el-form-item :label="$t('mdfeTranslate.Street')" prop="street">
                  <el-input v-model="invoiceDetail.street" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 详细地址 -->
                <el-form-item
                  :label="$t('placeOrder.detailedAddress')"
                  prop="detailedAddress"
                  :rules="[{required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change']}]"
                >
                  <el-input v-model="invoiceDetail.detailedAddress" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 补充地址 -->
                <el-form-item :label="$t('mdfeTranslate.SupplementalAddress')" prop="supplementaryAddress">
                  <el-input v-model="invoiceDetail.supplementaryAddress" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 社区 -->
                <el-form-item :label="$t('driver.modalNeighborhood')" prop="neighbourhood">
                  <el-input v-model="invoiceDetail.neighbourhood" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 门牌号 -->
                <el-form-item
                  :label="$t('placeOrder.HouseNumber')"
                  prop="houseNumber"
                  :rules="[{required: false, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change']}]"
                >
                  <el-input v-model="invoiceDetail.houseNumber" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- IBGE代码 -->
                <el-form-item :label="$t('mdfeTranslate.IBGECode')" prop="cityCode">
                  <el-input v-model="invoiceDetail.cityCode" disabled :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 电话号码 -->
                <el-form-item
                  :label="$t('orderCenterCont.telephoneNumber')"
                  prop="phoneNumber"
                  :rules="[
                    { required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change'] },
                    { validator: MobilePhoneNumber, trigger: ['blur', 'change'] }
                  ]"
                >
                  <el-input v-model="invoiceDetail.phoneNumber" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 邮箱 -->
                <el-form-item
                  :label="$t('orderDetails.email')"
                  prop="email"
                  :rules="[
                    { required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change'] },
                    { validator: E_Mail, trigger: ['blur', 'change'] }
                  ]"
                >
                  <el-input v-model="invoiceDetail.email" :placeholder="$t('collectionCenter.pleaseInput')" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-card>
<!--        <el-card class="box-card" style="margin-bottom: 10px;">-->
<!--          <div slot="header" class="clearfix">-->
<!--            &lt;!&ndash; 有效期限 &ndash;&gt;-->
<!--            <span>{{ $t('mdfeTranslate.ValidityPeriod') }}</span>-->
<!--          </div>-->
<!--          <div>-->
<!--            <el-row :gutter="10">-->
<!--              <el-col :span="10">-->
<!--                &lt;!&ndash; 起止时间 &ndash;&gt;-->
<!--                <el-form-item-->
<!--                  :label="$t('orderCenterCont.StartEndTimes')"-->
<!--                  prop="invoiceIssueTime"-->
<!--                  :rules="[-->
<!--                    {required: true, validator: timeRange, trigger: ['blur', 'change']}-->
<!--                  ]"-->
<!--                >-->
<!--                  <el-date-picker-->
<!--                    v-model="invoiceDetail.invoiceIssueTime"-->
<!--                    type="datetimerange"-->
<!--                    range-separator="-"-->
<!--                    value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                    :default-time="['00:00:00', '23:59:59']"-->
<!--                    :start-placeholder="$t('GlobalSetObj.startDate')"-->
<!--                    :end-placeholder="$t('GlobalSetObj.endDate')"-->
<!--                    style="width: 100%;"-->
<!--                  />-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </div>-->
<!--        </el-card>-->
      </el-form>
    </div>
    <div style="text-align: right;padding: 20px;border-top: 1px solid #ccc;">
      <el-button
        v-if="viewType !== 1"
        size="small" type="primary" @click="onSubmitDetailForm()"
      >{{ $t('collectionCenter.submit') }}</el-button>
      <el-button
        size="small" plain @click="onCloseDetailWindow()"
      >{{ $t('orderCenterCont.back') }}</el-button>
    </div>
  </div>
</template>
<script>
import {
  selectState,
  selectCity
} from '@/api/orderApi';
import { apiGetCustomerPage } from '@/api/finance/contasDeClientes';
import {
  E_Mail,
  MobilePhoneNumber,
  ieNumber
} from '@/utils/validate';
import { addOrUpdateInvoiceSubject, getInvoiceSubjectByCnpj, getAddressByZipCode } from '@/api/invoiceCenter';
export default {
  name: 'CustomerInvoiceDetail',
  props: {
    viewType: {
      type: Number,
      default: 0
    },
    detailData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    // 邮编
    const checkPostcode = async(rule, value, callback) => {
      const reg = /^\d{8}$/;
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        if (!reg.test(value)) {
          return callback(new Error(this.$t('mdfeTranslate.PostalCodeFormatIsIncorrect'))); // 邮编格式不正确
        } else {
          return callback();
        }
      }
    };
    // cnpj
    const checkcnpj = (rule, value, callback) => {
      const cnpjRegex = /^[a-zA-Z0-9]{9,12}\d{2}$/;
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        if (!cnpjRegex.test(value)) {
          return callback(new Error(this.$t('mdfeTranslate.enter11Digits14'))); // 输入11位或14位数字
        } else {
          callback();
        }
      }
    };
    // 有效期
    const timeRange = (rule, value, callback) => {
      console.log(value, '===value');
      if (!value || value.length < 2) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        const startTime = new Date(value[0]).getTime();
        const endTime = new Date(value[1]).getTime();
        const currentTime = new Date().getTime();
        if (startTime >= endTime) {
          return callback(new Error(this.$t('mdfeTranslate.StartTimeCannotGreaterThanEqualEndTime'))); // 起始时间不能大于或等于结束时间
        } else {
          if (startTime < currentTime) {
            return callback(new Error(this.$t('mdfeTranslate.StartTimeCannotLessCurrentTime'))); // 起始时间不能小于当前时间
          } else {
            callback();
          }
        }
      }
    };
    return {
      invoiceDetail: {
        customerId: '',
        invoiceCnpj: '',
        invoiceIe: '',
        companyShortName: '',
        customerName: '',
        companyFullName: '',
        postalCode: '',
        uf: '',
        city: '',
        supplementaryAddress: '',
        street: '',
        detailedAddress: '',
        neighbourhood: '',
        phoneNumber: '',
        email: '',
        cityCode: '',
        houseNumber: '',
        effectiveDate: '',
        expirationDate: '',
        invoiceIssueTime: []
      },
      senderStateList: [],
      cityList: [],
      customerOption: [],
      inputForm: {
        cnpj: '',
        state: ''
      },
      popoverVisible: false,
      isOneClickFillIn: false,
      checkPostcode,
      checkcnpj,
      MobilePhoneNumber,
      E_Mail,
      ieNumber,
      timeRange
    };
  },
  created() {
    this.getState();
    if (this.viewType !== 0) {
      this.invoiceDetail = JSON.parse(JSON.stringify(this.detailData));
      console.log(this.invoiceDetail, '===this.invoiceDetail');
      if (this.invoiceDetail.effectiveDate && this.invoiceDetail.expirationDate) {
        // 确保是有效的日期字符串
        const startDate = new Date(this.invoiceDetail.effectiveDate);
        const endDate = new Date(this.invoiceDetail.expirationDate);
        if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
          this.$set(this.invoiceDetail, 'invoiceIssueTime', [
            this.invoiceDetail.effectiveDate,
            this.invoiceDetail.expirationDate
          ]);
        }
      }
      // this.getCustomerOption(this.detailData.customerName);
    }
  },
  methods: {
    // 邮编变化
    async changePostalCode() {
      const reg = /^\d{8}$/;
      if (!reg.test(this.invoiceDetail.postalCode)) {
        return;
      }
      const param = {
        cep: this.invoiceDetail.postalCode
      };
      const { data } = await getAddressByZipCode(param);
      this.invoiceDetail.uf = data.uf;
      this.invoiceDetail.city = data.localidade;
      this.invoiceDetail.cityCode = data.ibge;
      if (!data.uf) {
        this.$message.warning(this.$t('mdfeTranslate.TheAddressCorrespondingToThePostalCodeDoesNotExist'));
      }
    },
    // 确定一键填入
    saveInput() {
      this.$refs.inputFormRef.validate(valid => {
        if (valid) {
          this.isOneClickFillIn = false;
          console.log(this.inputForm, '===inputForm');
          getInvoiceSubjectByCnpj(this.inputForm).then(res => {
            console.log(res, '===res');
            if (res.code === 200) {
              this.invoiceDetail.invoiceCnpj = res.data.cnpj;
              this.invoiceDetail.invoiceIe = res.data.ieNumber;
              this.invoiceDetail.companyShortName = res.data.abbreviation;
              this.invoiceDetail.companyFullName = res.data.name;
              this.invoiceDetail.postalCode = res.data.cep;
              this.invoiceDetail.uf = res.data.state;
              this.invoiceDetail.city = res.data.city;
              this.invoiceDetail.supplementaryAddress = res.data.complement;
              this.invoiceDetail.street = res.data.street;
              this.invoiceDetail.phoneNumber = res.data.phone;
              this.invoiceDetail.cityCode = res.data.cityCode;
              this.invoiceDetail.houseNumber = res.data.houseNumber;
              this.isOneClickFillIn = true;
              this.popoverVisible = false;
            }
          });
        }
      });
    },
    // 客户选项变化
    customerChange() {
      this.invoiceDetail.customerName = '';
      this.customerOption.map(item => {
        if (item.id === this.invoiceDetail.customerId) {
          this.invoiceDetail.customerName = item.username;
        }
      });
    },
    // 客户选项弹窗打开
    getCustomerOptionDialog(val) {
      if (val) {
        this.getCustomerOption();
      }
    },
    // 获取客户选项
    getCustomerOption(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          userNameOrId: name
        }
      };
      console.log(name, '===name');
      apiGetCustomerPage(param).then(res => {
        if (res.code === 200) {
          this.customerOption = res.data.records;
        }
      });
    },
    // 提交
    onSubmitDetailForm() {
      this.$refs.invoiceDetailRef.validate(valid => {
        if (valid) {
          console.log(this.invoiceDetail, '===invoiceDetail');
          const param = {
            customerId: this.invoiceDetail.customerId,
            invoiceCnpj: this.invoiceDetail.invoiceCnpj,
            invoiceIe: this.invoiceDetail.invoiceIe,
            companyShortName: this.invoiceDetail.companyShortName,
            customerName: this.invoiceDetail.customerName,
            companyFullName: this.invoiceDetail.companyFullName,
            postalCode: this.invoiceDetail.postalCode,
            uf: this.invoiceDetail.uf,
            city: this.invoiceDetail.city,
            supplementaryAddress: this.invoiceDetail.supplementaryAddress,
            street: this.invoiceDetail.street,
            detailedAddress: this.invoiceDetail.detailedAddress,
            phoneNumber: this.invoiceDetail.phoneNumber,
            email: this.invoiceDetail.email,
            cityCode: this.invoiceDetail.cityCode,
            houseNumber: this.invoiceDetail.houseNumber,
            neighbourhood: this.invoiceDetail.neighbourhood,
            effectiveDate: '',
            expirationDate: '',
            id: this.viewType === 0 ? '' : this.detailData.id
          };
          if (Array.isArray(this.invoiceDetail.invoiceIssueTime) && this.invoiceDetail.invoiceIssueTime.length === 2) {
            param.effectiveDate = this.invoiceDetail.invoiceIssueTime[0];
            param.expirationDate = this.invoiceDetail.invoiceIssueTime[1];
          } else {
            param.effectiveDate = null;
            param.expirationDate = null;
          }
          addOrUpdateInvoiceSubject(param).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('operationCenter.TheOperationSucceeded')); // 成功
              this.$emit('closeDetail', true);
            }
          });
        }
      });
    },
    // 关闭
    onCloseDetailWindow() {
      this.$emit('closeDetail');
    },
    // 获取州
    getState(name = '') {
      // level 0 州    1 城市   2 地区
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.senderStateList = res.data.records;
        }
      });
    },
    // 州省变化获取城市
    stateChangeOption() {
      this.invoiceDetail.city = '';
      // this.invoiceDetail.cityCode = '';
      this.cityList = [];
      this.getSenderCity();
    },
    // 城市选项弹窗打开
    cityOptionOpen(val) {
      if (val) {
        this.getSenderCity();
      }
    },
    // 获取城市
    getSenderCity(name = '') {
      let id = null;
      this.senderStateList.map((item) => {
        if (item.shortName === this.invoiceDetail.uf) {
          id = item.id;
        }
      });
      const params = {
        pageNumber: 1,
        pageSize: 100,
        params: {
          id,
          name
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.cityList = res.data.records;
        }
      });
    }
  }
};
</script>

<style>
.customerInvoiceDetail .el-card__header {
  padding: 10px;
  background: #f1f1f1;
  color: #000;
}
.customerInvoiceDetail .el-input.is-disabled .el-input__inner,
.customerInvoiceDetail .el-range-editor.is-disabled input{
  color: #000;
}
</style>
